import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import FundsMatured from '../../../../atoms/FundsMatured';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';

const FundsMaturedFormatter = (cellProps: CellProps) => {
  return (
    <CellEventsHandler cellProps={cellProps}>
      <FundsMatured maturityStatus={cellProps.row.fundsMatured} />
    </CellEventsHandler>
  );
};

export const FundsMaturedColumn = (): IColumn => ({
  item: {
    key: 'fundsMatured',
    name: 'Funds maturity',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(144px, 1.25fr)',
    formatter: FundsMaturedFormatter,
  },
  visible: ({ isFundsMatVisible }) => isFundsMatVisible!,
});
